import React, { FC } from 'react';
import { SystemManager } from '../../../utils/SystemManager';

const TarjetaOroDatos: FC = () => {
  return <div>{SystemManager.getSystem('tarjeta-oro-datos')}</div>;
};

export default TarjetaOroDatos;
